import type { MediaFileStatus, MediaFileType } from '../models/media-browser.view-model';

export interface MediaPreviewSource {
  type: MediaFileType;
  status: MediaFileStatus;
  previewUrl: string | null | undefined;
}

export interface ResolveMediaPreviewOptions {
  preferredRenditionUrl?: string | null;
  fallbackToPreviewUrl?: boolean;
}

export function resolveReadyImagePreviewUrl(
  file: MediaPreviewSource,
  options: ResolveMediaPreviewOptions = {},
): string | null {
  if (file.type !== 'IMAGE' || file.status !== 'READY') {
    return null;
  }

  const preferredRenditionUrl = normalizePreviewUrl(options.preferredRenditionUrl);
  if (preferredRenditionUrl) {
    return preferredRenditionUrl;
  }

  return options.fallbackToPreviewUrl === false
    ? null
    : normalizePreviewUrl(file.previewUrl);
}

function normalizePreviewUrl(url: string | null | undefined): string | null {
  const normalizedUrl = url?.trim();
  return normalizedUrl ? normalizedUrl : null;
}
